import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation';
import Home from './components/Home';
import HomeNew from './components/Home_New';
import About from './components/About';
import Services from './components/Services';
import EnhancedCalculator from './components/EnhancedCalculator';
import Contact from './components/Contact';
import BookingForm from './components/BookingForm';
import Knowledge from './components/Knowledge';
import Blog from './components/Blog';
import BlogArticle from './components/BlogArticle';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import StickyBookingButton from './components/StickyBookingButton';
import ScrollToTop from './components/ScrollToTop';
import FinancialAdvisorIndia from './components/FinancialAdvisorIndia';
import NRIFinancialPlanning from './components/NRIFinancialPlanning';
import MutualFundAdvisor from './components/MutualFundAdvisor';
import RetirementPlanningIndia from './components/RetirementPlanningIndia';
import WealthManagementServices from './components/WealthManagementServices';
import EquityTrading from './components/services/EquityTrading';
import PortfolioManagement from './components/services/PortfolioManagement';
import CorporateBonds from './components/services/CorporateBonds';
import GoldBonds from './components/services/GoldBonds';
import FixedDeposits from './components/services/FixedDeposits';
import CommodityTrading from './components/services/CommodityTrading';
import NriUK from './components/nri/NriUK';
import NriUAE from './components/nri/NriUAE';
import NriUS from './components/nri/NriUS';
import { Toaster } from 'sonner';
import './App.css';

function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white">
        <Navigation />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home-new" element={<HomeNew />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/calculator" element={<EnhancedCalculator />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book-consultation" element={<BookingForm />} />
            
            {/* Landing Pages */}
            <Route path="/financial-advisor-india" element={<FinancialAdvisorIndia />} />
            <Route path="/nri-financial-planning" element={<NRIFinancialPlanning />} />
            <Route path="/mutual-fund-advisor" element={<MutualFundAdvisor />} />
            <Route path="/retirement-planning-india" element={<RetirementPlanningIndia />} />
            <Route path="/wealth-management-services" element={<WealthManagementServices />} />
            
            {/* Service-Specific Landing Pages */}
            <Route path="/services/equity-trading" element={<EquityTrading />} />
            <Route path="/services/portfolio-management" element={<PortfolioManagement />} />
            <Route path="/services/corporate-bonds" element={<CorporateBonds />} />
            <Route path="/services/gold-bonds" element={<GoldBonds />} />
            <Route path="/services/fixed-deposits" element={<FixedDeposits />} />
            <Route path="/services/commodity-trading" element={<CommodityTrading />} />
            
            {/* NRI Geo-Targeted Pages */}
            <Route path="/nri/uk" element={<NriUK />} />
            <Route path="/nri/uae" element={<NriUAE />} />
            <Route path="/nri/us" element={<NriUS />} />
          </Routes>
        </main>
        <Footer />
        
        {/* Floating Action Buttons */}
        <Chatbot />
        
        <Toaster position="top-right" richColors />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;